"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = exports.auth = void 0;
const errors_1 = require("../../server/errors");
const getAuth_1 = require("../../server/getAuth");
const utils_1 = require("./utils");
const auth = () => {
    return (0, getAuth_1.createGetAuth)({
        debugLoggerName: 'auth()',
        noAuthStatusMessage: (0, errors_1.authAuthHeaderMissing)(),
    })((0, utils_1.buildRequestLike)());
};
exports.auth = auth;
const initialState = () => {
    return (0, getAuth_1.buildClerkProps)((0, utils_1.buildRequestLike)());
};
exports.initialState = initialState;
